import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import DownloadProj from '../../assets/images/svg/print.svg';
import { generateProjetoPdf } from '../../store/modules/ProjetoActions';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import { isGeneratingPdfById } from '../../utils/ProjetoUtils';
import RefreshIcon from '../Icons/RefreshIcon';
import styles from './DownloadProjeto.scss';
const rootClassName = styles.rootClassName;

class DownloadProjeto extends Component {
  onGenerateProjetoPdfSuccess = (resp) => {
    const blob = new Blob([resp], {
      type: 'application/pdf',
    });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'projeto-' + this.props.projetoId;
    link.class = 'hidden-button';
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  onGenerateProjetoPdfError = (error) => {
    SnackbarUtils.enqueueSnackbar({
      message:
        error.response.statusText ||
        this.props.languageValues.errorGenerateProjetoPdf,
      options: {
        variant: 'error',
      },
    });
  };

  generateProjetoPdf = () => {
    this.props.generateProjetoPdf(
      this.props.projetoId,
      null,
      this.onGenerateProjetoPdfSuccess,
      this.onGenerateProjetoPdfError
    );
  };

  render() {
    if (
      isGeneratingPdfById(
        this.props.projetos.generatingPdfById,
        this.props.projetoId
      )
    ) {
      return this.renderLoading();
    } else {
      return this.renderLoadProjeto();
    }
  }

  renderLoading = () => {
    return <RefreshIcon style={{ marginLeft: 11 }} />;
  };

  renderLoadProjeto = () => {
    return (
      <button
        onClick={() => this.generateProjetoPdf()}
        className={getMergedClassNames([
          rootClassName,
          this.props.className,
          this.props.disabled ? rootClassName + '-disabled' : '',
        ])}
        disabled={this.props.disabled}
      >
        <img
          src={DownloadProj}
          width={24}
          height={24}
          alt={this.props.languageValues.labelModalDownloadProjeto}
          loading='lazy'
        />
      </button>
    );
  };
}

DownloadProjeto.propTypes = {
  projetoId: PropTypes.number.isRequired,
  className: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  projetos: state.projeto,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      generateProjetoPdf,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DownloadProjeto);
